import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { mediaUrl, uploadImage } from "./contentApi";

// Image path field: upload a file or paste a URL, with a preview.
export default function ImageField({ label, value, onChange, hint }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      onChange(await uploadImage(file));
    } catch (err) {
      toast.error(err.message);
    }
    setUploading(false);
  };

  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <div className="d-flex gap-2 align-items-start">
        <input
          type="text"
          className="form-control"
          placeholder="/uploads/… or https://…"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <label className="btn btn-light mb-0 text-nowrap" style={{ cursor: uploading ? "wait" : "pointer" }}>
          {uploading ? <Spinner size="sm" /> : "Upload"}
          <input type="file" accept="image/jpeg,image/png,image/webp,image/avif" hidden onChange={handleFile} disabled={uploading} />
        </label>
        {value && (
          <Button color="light" outline onClick={() => onChange("")} title="Remove">
            ✕
          </Button>
        )}
      </div>
      {hint && <div className="form-note mt-1">{hint}</div>}
      {value && (
        <img src={mediaUrl(value)} alt="" className="mt-2 rounded border" style={{ maxWidth: 240, maxHeight: 140, objectFit: "cover" }} />
      )}
    </div>
  );
}
